export const POST_LIST = 'post-list-data';
export const POST_DETAIL = 'post-detail-data';
export const LOADING_POST_DETAIL = 'loading-post-detail-data';
